module.exports = __webpack_public_path__ + "static/media/charger-2.c5f342f2.png";